export function autoload(contextModule, application) {
  contextModule.keys().forEach(function (key) {
    var identifier = getIdentifierForContextKey(key);

    if (identifier) {
      var controllerConstructor = contextModule(key).default;

      if (typeof controllerConstructor == "function") {
        application.register(identifier, controllerConstructor);
      }
    }
  });
}

function getIdentifierForContextKey(key) {
  var dasherizedKey = key.replace(/_/g, "-");
  var matches = dasherizedKey.match(/([\w-]+)-controller(\.\w+)?$/i);

  if (matches) {
    var identifier = matches[1].replace(/-controller$/i, "");

    if (identifier) {
      return identifier;
    }
  }
}